











import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'VBarItemOverall'
})
export default class VBarItemOverall extends Vue {
  @Prop({ required: true }) value?: number;
  @Prop({ required: true }) name?: string;
  @Prop({ required: true }) color?: string;
  @Prop({ required: true }) percent?: string;
  @Prop({ required: true }) max?: number;
  @Prop({ required: true }) tabId?: number;
  public style = `width: 0%; margin: 0; padding: 0; background-color: ${this.color}`;

  @Watch('tabId', { deep: false, immediate: true })
  public updateTabId() {
    this.setStyle();
  }

  @Watch('value', { deep: false, immediate: true })
  public updateValue() {
    this.setStyle();
  }

  @Watch('max', { deep: false, immediate: true })
  public updateMax() {
    this.setStyle();
  }

  public setStyle() {
    this.style = `width: 0; background-color: ${this.color}`;
    setTimeout(() => {
      if (this.max && this.value)
        this.style = `width: ${(this.value * 100) /
          this.max}%; background-color: ${this.color}`;
      else this.style = `width: 0.1%; background-color: ${this.color}`;
    }, 300);
  }
}
